import { Component, Input, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { DocumentContract } from '../../../_models/document-contract';
import { D4signAccountBalanceDTO } from '../../../_models/_dto/d4sign-account-balance.dto';
import { ContractDocumentService } from '../../../_services/contract-document.service';

@Component({
	selector: 'contracts-processing-file',
	styles: [require('./contracts-processing-file.component.css')],
	template: require('./contracts-processing-file.component.html')
})

export class ContractsProcessingFileComponent implements OnInit {

	@Input() accountBalance: D4signAccountBalanceDTO;

	documentsProcessingFile: DocumentContract[] = [];
	selectedDocuments: DocumentContract[] = [];

	constructor(
		public dialog: MdDialog,
		private contractDocumentService: ContractDocumentService
	) { }

	async ngOnInit() {
		this.findDocuments();
	}

	findDocuments(): void {
		this.contractDocumentService.getProcessingFileDocuments()
			.subscribe((data) => {
				this.documentsProcessingFile = data;
			}, (error) => console.log(error));
	}

	sendDocumentToD4sign(document: DocumentContract) {
		this.contractDocumentService.sendProcessingFileDocuments([document.id])
			.subscribe(() => {
				console.log('sucesso');
				this.findDocuments();
			}, (error) => console.log(error));
	}

	sendDocumentsSelectedToD4sign() {
		const ids = this.selectedDocuments.map(document => document.id)
		this.contractDocumentService.sendProcessingFileDocuments(ids)
			.subscribe(() => {
				console.log('sucesso')
				this.findDocuments();
			}, (error) => console.log(error));

	}

	isSelectable(document: DocumentContract): boolean {
		return this.accountBalance && this.selectedDocuments.length >= this.accountBalance.balanceSignatures && this.selectedDocuments.find(d => d === document) === undefined;
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/contracts-balance/contracts-processing-file/contracts-processing-file.component.ts